
export default function waitlistSelect(state = null, action) {
    switch (action.type) {
        case 'ui/waitlistSelect/add':{
            return action.payload
        }
        default:
            return state
    }
  }